import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "application-page-header" }
const _hoisted_2 = { class: "cu-logo-wrapper" }
const _hoisted_3 = ["src"]

import { computed } from "vue";
import { useStore } from "vuex";

export default /*@__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const store = useStore();
const cuLogoUrl = computed(() => store.getters["cuLogoUrl"]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: cuLogoUrl.value,
        alt: "Logo",
        class: "cu-logo"
      }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})